import React, { Component } from "react";
import {Col, Button, Form, FormGroup, FormControl, ControlLabel, Checkbox} from 'react-bootstrap';
import { Link, Redirect } from 'react-router-dom';


export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: ''
    };
  }

  componentDidMount() {

  }
  render() {
    
  

    const checkLogin = () => {

      const username = "admin";
      const password = "admin";

      if (this.state.username === username && this.state.password === password) {
        console.log("yikes")
        this.props.history.push('/admin')
      }

      else {
          this.props.history.push('/game')
      }

    }
    return (
      <div className="container">
        <Form horizontal>
  <FormGroup controlId="formHorizontalEmail">
    <Col componentClass={ControlLabel} sm={2}>
      Username
    </Col>
    <Col sm={10}>
      <FormControl placeholder="Username" value={this.state.inputValue} onChange={evt => this.setState({username: evt.target.value})}/>
    </Col>
  </FormGroup>

  <FormGroup controlId="formHorizontalPassword">
    <Col componentClass={ControlLabel} sm={2}>
      Password
    </Col>
    <Col sm={10}>
      <FormControl type="password" placeholder="Password" value={this.state.inputValue} onChange={evt => this.setState({password: evt.target.value})}/>
    </Col>
  </FormGroup>

  <FormGroup>
    <Col smOffset={2} sm={10}>
      <Checkbox>Remember me</Checkbox>
    </Col>
  </FormGroup>

  <FormGroup>
    <Col smOffset={2} sm={10}>
      <Button  className="btn-sample" onClick={() => {console.log("Username: " + this.state.username + "\nPassword: " + this.state.password), checkLogin()}}>Login</Button>
      {' '}
    </Col>
  </FormGroup>
</Form>
      </div>
    );
  }
  
}



// WEBPACK FOOTER //
// ./src/components/Home.jsx